import { render } from "./MasterLayout.vue?vue&type=template&id=c28dcd5c&scoped=true"
import script from "./MasterLayout.vue?vue&type=script&lang=js"
export * from "./MasterLayout.vue?vue&type=script&lang=js"

import "./MasterLayout.vue?vue&type=style&index=0&id=c28dcd5c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28dcd5c"]])

export default __exports__